

export const globals={
    rickmortyApiBaseUrl: 'https://rickandmortyapi.com/api/'
}